import React, { useEffect, useState } from 'react';
import { money, STATUS_TEXT } from '../shop';
import { getOrder, cancelOrder } from '../api';
import { ProductPhoto } from './Photo';

const STEPS = ['received', 'baking', 'ready', 'collected'];

export function OrderPage({ id, justPlaced, catalog = [], onBack }) {
  const [order, setOrder] = useState(justPlaced && justPlaced.id === id ? justPlaced : null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let live = true;
    getOrder(id).then((o) => live && setOrder(o)).catch((err) => live && setError(err.status === 404 ? 'We could not find that order.' : err.message));
    return () => { live = false; };
  }, [id]);

  const cancel = async () => {
    if (!window.confirm('Cancel this order?')) return;
    setBusy(true);
    try {
      setOrder(await cancelOrder(order.id));
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  if (error && !order) return <section className="order-page"><p className="form-error">{error}</p><button type="button" className="btn btn-dark" onClick={onBack}>Back to the shop</button></section>;
  if (!order) return <div className="loading"><div className="spinner" /><p>Loading your order…</p></div>;
  const at = STEPS.indexOf(order.status);
  const byId = new Map(catalog.map((p) => [p.id, p]));
  return (
    <section className="order-page">
      {justPlaced && justPlaced.id === id && (
        <div className="thanks">
          <span className="check" aria-hidden="true">✓</span>
          <div><p className="thanks-title">Thank you, {order.customer.name}! Your order is in.</p>
            <p>We will bake it fresh. Bookmark this page to follow your order.</p></div>
        </div>
      )}
      <p className="kicker">Your order</p>
      <h1>Order <code>{order.id.slice(0, 8)}</code></h1>
      <p className="muted">Keep this page's address to check your order later. Placed {new Date(order.createdAt).toLocaleString()}{order.pickupDate ? ` · pickup ${order.pickupDate}` : ''}.</p>
      {order.status === 'cancelled' ? (
        <p className="status cancelled">{STATUS_TEXT.cancelled}</p>
      ) : (
        <ol className="progress">{STEPS.map((s, i) => <li key={s} className={i <= at ? 'done' : ''}>{s}</li>)}</ol>
      )}
      <p className="status">{STATUS_TEXT[order.status]}</p>
      <ul className="cart-lines">
        {order.items.map((l) => (
          <li key={l.productId}><ProductPhoto product={byId.get(l.productId)} className="thumb" /><span className="cart-name">{l.name}<small>{l.quantity} × {money(l.unitPriceCents)}</small></span><span className="cart-total">{money(l.lineTotalCents)}</span></li>
        ))}
      </ul>
      <dl className="totals">
        <dt>{order.quantity} macarons</dt><dd>{money(order.subtotalCents)}</dd>
        {order.discountCents > 0 && (<><dt>{order.discountLabel}</dt><dd>−{money(order.discountCents)}</dd></>)}
        <dt className="grand">Total (pay at pickup)</dt><dd className="grand">{money(order.totalCents)}</dd>
      </dl>
      {order.note && <p className="muted">Note: {order.note}</p>}
      {error && <p className="form-error" role="alert">{error}</p>}
      <div className="drawer-actions">
        <button type="button" className="link-btn" onClick={onBack}>Back to the shop</button>
        {order.cancellable && order.id === id && <button type="button" className="btn btn-danger" disabled={busy} onClick={cancel}>Cancel order</button>}
      </div>
    </section>
  );
}
